import { useState, useEffect, useCallback } from 'react';

const WHATSAPP_URL = 'https://wa.me/5516981106759?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20jur%C3%ADdica';

const slides = [
  {
    image: 'https://readdy.ai/api/search-image?query=dramatic%20premium%20law%20office%20interior%20at%20night%2C%20large%20floor%20to%20ceiling%20windows%20overlooking%20city%20lights%2C%20dark%20navy%20blue%20atmosphere%2C%20scales%20of%20justice%20on%20wooden%20desk%2C%20leather%20chairs%2C%20sophisticated%20elegant%20legal%20workspace%2C%20cinematic%20high%20contrast%20photography%2C%20deep%20blue%20shadows%20with%20golden%20accent%20lighting&width=1920&height=1080&seq=hero1&orientation=landscape',
    title: 'Foi vítima de golpe bancário?',
    subtitle: 'Recupere seu dinheiro com apoio jurídico especializado e atendimento imediato.',
    cta: 'Falar agora no WhatsApp',
    href: WHATSAPP_URL,
    external: true,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=abstract%20digital%20cybersecurity%20concept%20with%20glowing%20blue%20shield%20and%20golden%20lock%2C%20flowing%20data%20streams%2C%20dark%20deep%20blue%20background%20with%20circuit%20board%20patterns%2C%20financial%20protection%20digital%20security%20theme%2C%20professional%20technology%20atmosphere%2C%20high%20resolution%20dramatic%20lighting&width=1920&height=1080&seq=hero2&orientation=landscape',
    title: 'Teve sua conta invadida?',
    subtitle: 'Atuamos na recuperação de contas digitais e proteção jurídica dos seus dados.',
    cta: 'Solicitar Ajuda',
    href: '#contato',
    external: false,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=dark%20abstract%20digital%20fraud%20concept%2C%20shattered%20glowing%20red%20lock%20icon%20surrounded%20by%20broken%20credit%20cards%20and%20scattered%20dollar%20signs%20floating%20in%20black%20deep%20space%2C%20streams%20of%20corrupted%20red%20and%20gold%20binary%20code%2C%20dark%20sinister%20cyberspace%20atmosphere%2C%20no%20people%20no%20office%20no%20humans%2C%20dramatic%20high%20contrast%20cinematic%20lighting%2C%20ultra%20detailed%20digital%20art&width=1920&height=1080&seq=hero3v2&orientation=landscape',
    title: 'Soluções rápidas para fraudes digitais',
    subtitle: 'Atendimento ágil e especializado para resolver situações urgentes com eficiência.',
    cta: 'Entrar em Contato',
    href: '#contato',
    external: false,
  },
];

export default function HeroSlider() {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const goTo = useCallback((index: number) => {
    if (transitioning) return;
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setTransitioning(false);
    }, 400);
  }, [transitioning]);

  const next = useCallback(() => goTo((current + 1) % slides.length), [current, goTo]);

  useEffect(() => {
    const timer = setInterval(next, 6000);
    return () => clearInterval(timer);
  }, [next]);

  const handleCTA = (e: React.MouseEvent<HTMLAnchorElement>, slide: typeof slides[0]) => {
    if (!slide.external) {
      e.preventDefault();
      const el = document.querySelector(slide.href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative w-full h-screen min-h-[640px] overflow-hidden">
      {slides.map((slide, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-700"
          style={{ opacity: i === current && !transitioning ? 1 : 0, zIndex: i === current ? 1 : 0 }}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
            loading={i === 0 ? 'eager' : 'lazy'}
          />
        </div>
      ))}

      {/* Overlay */}
      <div
        className="absolute inset-0 z-10"
        style={{ background: 'linear-gradient(to right, rgba(11,47,91,0.88) 45%, rgba(11,47,91,0.55) 100%)' }}
      />

      {/* Content */}
      <div className="relative z-20 h-full flex items-center">
        <div className="w-full px-6 sm:px-10 lg:px-14 xl:px-20 flex flex-col items-center lg:items-start">
          <div className="max-w-2xl w-full text-center lg:text-left">
            <div
              className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase mb-6"
              style={{ background: 'rgba(201,162,74,0.18)', border: '1px solid rgba(201,162,74,0.4)', color: '#E1C67A' }}
            >
              <span className="w-2 h-2 rounded-full inline-block" style={{ background: '#C9A24A' }} />
              Atendimento Imediato
            </div>

            <h1
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 transition-all duration-500"
              style={{ textShadow: '0 2px 24px rgba(0,0,0,0.3)' }}
            >
              {slides[current].title}
            </h1>

            <p className="hidden sm:block text-white/85 text-lg md:text-xl leading-relaxed mb-4 sm:mb-8 max-w-xl mx-auto lg:mx-0">
              {slides[current].subtitle}
            </p>

            {/* Mobile: subtitle centered between arrows */}
            <div className="flex sm:hidden items-center gap-3 mb-6">
              <button
                onClick={() => goTo((current - 1 + slides.length) % slides.length)}
                className="flex-shrink-0 flex items-center justify-center cursor-pointer transition-all duration-300 active:scale-95 hover:scale-110 p-1"
                style={{ filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.95))' }}
                aria-label="Slide anterior"
              >
                <i className="ri-arrow-left-s-line" style={{ color: '#E1C67A', fontSize: '2rem', fontWeight: 700 }} />
              </button>
              <p className="text-white/85 text-base leading-relaxed text-center flex-1">
                {slides[current].subtitle}
              </p>
              <button
                onClick={() => goTo((current + 1) % slides.length)}
                className="flex-shrink-0 flex items-center justify-center cursor-pointer transition-all duration-300 active:scale-95 hover:scale-110 p-1"
                style={{ filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.95))' }}
                aria-label="Próximo slide"
              >
                <i className="ri-arrow-right-s-line" style={{ color: '#E1C67A', fontSize: '2rem', fontWeight: 700 }} />
              </button>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href={slides[current].href}
                target={slides[current].external ? '_blank' : undefined}
                rel={slides[current].external ? 'noopener noreferrer' : undefined}
                onClick={(e) => handleCTA(e, slides[current])}
                className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full font-bold text-base cursor-pointer whitespace-nowrap transition-all duration-300 hover:scale-105"
                style={{ background: '#C9A24A', color: '#0B2F5B', boxShadow: '0 8px 24px rgba(201,162,74,0.4)' }}
              >
                <i className="ri-whatsapp-line text-xl" />
                {slides[current].cta}
              </a>
              <a
                href="#servicos"
                onClick={(e) => { e.preventDefault(); document.querySelector('#servicos')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-semibold text-base cursor-pointer whitespace-nowrap transition-all duration-300 text-white hover:bg-white/10"
                style={{ border: '2px solid rgba(255,255,255,0.4)' }}
              >
                Ver Serviços
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className="cursor-pointer transition-all duration-300 rounded-full"
            style={{
              width: i === current ? '32px' : '10px',
              height: '10px',
              background: i === current ? '#C9A24A' : 'rgba(255,255,255,0.4)',
            }}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Side arrows — desktop only */}
      <button
        onClick={() => goTo((current - 1 + slides.length) % slides.length)}
        className="hidden sm:flex absolute left-6 top-1/2 -translate-y-1/2 z-20 items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110 active:scale-95"
        style={{ filter: 'drop-shadow(0 2px 10px rgba(0,0,0,0.95))' }}
        aria-label="Slide anterior"
      >
        <i className="ri-arrow-left-s-line" style={{ color: '#E1C67A', fontSize: '2.5rem', fontWeight: 700 }} />
      </button>
      <button
        onClick={() => goTo((current + 1) % slides.length)}
        className="hidden sm:flex absolute right-6 top-1/2 -translate-y-1/2 z-20 items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110 active:scale-95"
        style={{ filter: 'drop-shadow(0 2px 10px rgba(0,0,0,0.95))' }}
        aria-label="Próximo slide"
      >
        <i className="ri-arrow-right-s-line" style={{ color: '#E1C67A', fontSize: '2.5rem', fontWeight: 700 }} />
      </button>

      {/* Scroll down hint */}
      <div className="absolute bottom-10 right-10 z-20 flex flex-col items-center gap-2 opacity-60">
        <span className="text-white text-xs tracking-widest uppercase" style={{ writingMode: 'vertical-rl' }}>Rolar</span>
        <div className="w-px h-12 bg-white/40" />
      </div>
    </section>
  );
}
